import { render } from "./CadastroPagamento.vue?vue&type=template&id=1709752e&scoped=true&lang=html"
import script from "./CadastroPagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroPagamento.vue?vue&type=script&setup=true&lang=js"

import "./CadastroPagamento.vue?vue&type=style&index=0&id=1709752e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1709752e"]])

export default __exports__